<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-3">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('buildingDetails.managementOrders') }}</router-link> /
            <span class="color-main">{{ $t('buildingDetails.newOrderDetails') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('buildingDetails.moreAboutSaqf') }}</p>
        </div>
        <div class="flex-sm-gap def-wid">
          <router-link
            :to="{ name: 'editBuilding', params: { id: route.params.id } }"
            class="main-btn up"
          >
            {{ $t('buildingDetails.editBuilding') }}
          </router-link>
          <button
            class="main-btn up bg-red"
            type="button"
            @click="confirmRemove = true"
          >
            {{ $t('buildingDetails.deleteBuilding') }}
          </button>
        </div>
      </div>
      <div class="details-card mb-4">
        <div class="card-details-title">{{ $t('buildingDetails.orderData') }}</div>
        <div class="card-rows">
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.additionDate') }}</div>
            <div class="second-info">{{ date }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingName') }}</div>
            <div class="second-info">{{ name }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingType') }}</div>
            <div class="second-info">{{ type }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingAge') }}</div>
            <div class="second-info">{{ age }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingArea') }}</div>
            <div class="second-info">
              {{ area }}
            </div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.tenantsCount') }}</div>
            <div class="second-info">{{ tenants }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingAddress') }}</div>
            <div class="second-info">
              <i class="fa-solid fa-location-dot color-main"></i> &nbsp;
              {{ address }}
            </div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingUse') }}</div>
            <div class="second-info">{{ use }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.buildingCode') }}</div>
            <div class="second-info">{{ code }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.agreedRatio') }}</div>
            <div class="second-info">{{ percent }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('buildingDetails.apartmentsCount') }}</div>
            <div class="second-info">{{ number }}</div>
          </div>
          <div class="flex-loop-row" v-if="shops_count">
            <div class="first-info gray-col">{{ $t('buildingDetails.shopsCount') }}</div>
            <div class="second-info">{{ shops_count }}</div>
          </div>
        </div>
      </div>
      <div class="card-details-def mb-4">
        <h6 class="color-main mb-2">{{ $t('buildingDetails.buildingDescription') }}</h6>
        <p class="gray-col">
          {{ desc }}
        </p>
      </div>
      <div class="card-details-def" v-if="owner">
        <h6 class="color-main mb-3">{{ $t('buildingDetails.ownerData') }}</h6>
        <div class="flex-sm-gap mb-3">
          <img :src="userImg" class="img-user" alt="" />
          <div class="user-data-card">
            <div class="color-main mb-2">{{ ownerName }}</div>
            <a href="tel:01097054537" target="_blank" class="phone-info black">
              <div class="phone-icon"><i class="fa-solid fa-phone"></i></div>
              {{ ownerPhone }}
            </a>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-3">
        <router-link  :to="{ name: 'tenantsView', params: { id: route.params.id  } , query: { name: name } }" class="tenants">
          <div>
            {{ $t('buildingDetails.tenants') }} <strong>({{ tenants }})</strong>
          </div>
          <i class="fa-solid fa-angle-left"></i>
        </router-link>
      </div>
      <div class="card-details-def">
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('buildingDetails.managementContract') }}</div>
          </div>
          <a :href="down1" target="_blank" download class="downloadlink"
            >{{ $t('buildingDetails.downloadContract') }}</a
          >
        </div>
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('buildingDetails.propertyDeed') }}</div>
          </div>
          <a :href="down2" target="_blank" download class="downloadlink"
            >{{ $t('buildingDetails.downloadDeed') }}</a
          >
        </div>
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('buildingDetails.constructionCertificate') }}</div>
          </div>
          <a :href="down3" target="_blank" download class="downloadlink"
            >{{ $t('buildingDetails.downloadCertificate') }}</a
          >
        </div>
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('buildingDetails.civilDefenseCertificate') }}</div>
          </div>
          <a :href="down4" target="_blank" download class="downloadlink"
            >{{ $t('buildingDetails.downloadCertificate') }}</a
          >
        </div>
      </div>
    </div>
  </main>

  <!-- confirm modal  -->
  <Dialog v-model:visible="confirmRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="dangerImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('buildingDetails.confirmDeleteBuilding') }}
      </h6>
      <div class="flex-group-me mb-3">
        <button
          type="button"
          :disabled="disabled"
          class="main-btn lg up bg-red"
          @click="removeBuilding"
        >
          <div v-if="!disabled">{{ $t('buildingDetails.yesDelete') }}</div>
          <div class="loading" role="status" v-if="disabled">
            {{ $t('buildingDetails.deleting') }}
            <div class="spinner-small-white" v-if="disabled"></div>
          </div>
        </button>
        <button
          type="button"
          class="main-btn lg up bg-trans"
          @click="confirmRemove = false"
        >
          {{ $t('buildingDetails.cancel') }}
        </button>
      </div>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="suceessRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('buildingDetails.buildingDeletedSuccess') }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link to="/buildingsView" class="main-btn lg up"
          >{{ $t('buildingDetails.properties') }}</router-link
        >
        <router-link to="/dashboardHome" class="main-btn lg up bg-trans"
          >{{ $t('buildingDetails.home') }}</router-link
        >
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import Dialog from "primevue/dialog";
import axios from "axios";
import { ref, onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
const route = useRoute();
import { useRoute } from "vue-router";

// reactive state
const userImg = ref(
  require("../assets/imgs/185644495_1667380803456791_1968050560740665054_n.jpg")
);
const fileImg = ref(require("../assets/imgs/pdf.png"));
const successImg = ref(require("../assets/imgs/check.png"));
const dangerImg = ref(require("../assets/imgs/noun_warning.png"));
const suceessRemove = ref(false);
const confirmRemove = ref(false);
const owner = ref(true);
const disabled = ref(false);

//  refs details
const name = ref("");
const type = ref("");
const date = ref("");
const age = ref("");
const area = ref("");
const count = ref("");
const address = ref("");
const use = ref("");
const code = ref("");
const percent = ref("");
const number = ref("");
const desc = ref("");
const down1 = ref("");
const down2 = ref("");
const down3 = ref("");
const down4 = ref("");
const ownerName = ref("");
const ownerPhone = ref("");
const tenants = ref("");
const shops_count = ref("");

// functions
function removeBuilding() {
  disabled.value = true;
  // const fd = new FormData();

  axios
    .delete(`manager/delete-building/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        suceessRemove.value = true;
        confirmRemove.value = false;
        setTimeout(function () {
          router.push("/buildingsView");
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

function getBuilding() {
  axios
    .get(`/manager/building-details/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      console.log(response.data.data);
      name.value = response.data.data.name;
      type.value = response.data.data.type.name;
      date.value = response.data.data.created_at;
      age.value = response.data.data.age_text;
      area.value = response.data.data.area_text;
      count.value = response.data.data.users_count;
      address.value = response.data.data.map_desc;
      address.value = response.data.data.map_desc;
      use.value = response.data.data.specification;
      code.value = response.data.data.ref_code;
      percent.value = response.data.data.ratio_text;
      number.value = response.data.data.units_count;
      desc.value = response.data.data.description;
      shops_count.value = response.data.data.shops_count;
      if (response.data.data.owner) {
        owner.value = true;
        userImg.value = response.data.data.owner.image;
        ownerName.value = response.data.data.owner.name;
        ownerPhone.value = response.data.data.owner.phone;
      } else {
        owner.value = false;
      }
      tenants.value = response.data.data.rentals_count;
      down1.value = response.data.data.contract;
      down2.value = response.data.data.instrument;
      down3.value = response.data.data.construction_completion_certificate;
      down4.value = response.data.data.civil_defense_certificate;
    });
}

// lifecycle hooks
onMounted(() => {
  getBuilding();
});
</script>
